import styled from "styled-components";

export const Container = styled.div`
    .bgHeader{
        width: 100%;
        height: 120px;
        background-color: #fbe777;
    }

    // header{
    //     width: 100%;
    //     position: relative;
    //     margin: auto;
    //     margin-top: -65px;
    //     .headerContent{
    //         display: flex;
    //         align-items: flex-start;
    //         justify-content: space-between;
    //         max-width: 1420px;
    //         width: 90%;
    //         margin: auto;
    //         .logo{
    //             width: 200px;
    //             position: relative;
    //             z-index: 99;
    //         }
    //         .central{
    //             width: 400px;
    //         }
    //         .icons{
    //             margin-top: 100px;
    //             display: flex;
    //             flex-direction: column;
    //             gap: 20px;
    //             img{
    //                 width: 50px;
    //             }
    //         }
    //     }
        // &::before{
        //     content: '';
        //     position: absolute;
        //     left: -160px;
        //     top: -85px;
        //     background-image: url('./assets/img/filme.svg');
        //     background-position: center;
        //     background-size: cover;
        //     background-repeat: no-repeat;
        //     width: 420px;
        //     height: 490px;
        //     z-index: 98;
        // }
    }
    .HomeText{
        max-width: 1420px;
        width: 90%;
        margin: auto;
        
        .initialImg{
            margin: auto;
            width: 600px;
            height: auto;
            margin-bottom: 2rem;
        }

        a{
            background-color: #0d5b5b;
            text-transform: uppercase;
            font-weight: bold;
            color: #fbe777;
            display: flex;
            align-items: center;
            font-size: 1.3em;
            justify-content: center;
            width: 350px;
            height: 50px;
            border-radius: 30px;
            padding: 0px 10px;
            margin: auto;
        }

        .bnts{
            display: flex;
            align-items: flex-start;
            gap: 60px;
            justify-content: center;
            margin-top: 3rem;
            text-align: center;

            p{
                margin-bottom: 20px;
            }

            a{
                width: 250px;
                border-radius: 10px;
            }
        }
    }

    @media only screen and (max-width: 1080px) {
        header .headerContent {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: auto;
            gap: 20px;
            .logo{
                width: 150px;
            }

            .icons{
                margin-top: 0px;
                flex-direction: row;
                margin-bottom: 2rem;
            }
        }

        header::before{
            display: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .HomeText .bnts {
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
`;

